import React from "react";
import "./copy.scss";

const Copy = () => {
  return (
    <div className="copy">
      <p>© 2025 Fundación Creciendo Feliz. All Rights Reserved.</p>
    </div>
  );
};

export default Copy;
